//imports
import {
    PM_USERS_CREATE_USER_REQUEST,
    PM_USERS_CREATE_USER_RESULT,
    PM_USERS_UPDATE_USER_REQUEST,
    PM_USERS_UPDATE_USER_RESULT,
    PM_USERS_DELETE_USER_REQUEST,
    PM_USERS_DELETE_USER_RESULT,
    PM_USERS_SEARCH_ROLES_RESULT,
    PM_USERS_CREATE_USER_OPEN_MODAL,
    PM_USERS_CREATE_USER_CLOSE_MODAL,
    PM_USERS_GET_USER_RESULT,
    PM_USERS_GET_USER_REQUEST,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    createUserLoading: false,
    createUser: null,
    updateUserLoading: false,
    updateUser: null,
    deleteUserLoading: false,
    deleteUser: null,
    openModal: false,
    roles: [],
    getUserLoading: false,
    user: null,
    currentId: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PM_USERS_CREATE_USER_OPEN_MODAL:
            return { ...state, openModal: true, currentId: action.payload?.id || null }

        case PM_USERS_CREATE_USER_CLOSE_MODAL:
            return { ...state, openModal: false }

        case PM_USERS_GET_USER_REQUEST:
            return { ...state, getUserLoading: true }

        case PM_USERS_GET_USER_RESULT:
            return { ...state, getUserLoading: false, user: action.payload }

        case PM_USERS_CREATE_USER_REQUEST:
            return { ...state, createUserLoading: true }

        case PM_USERS_CREATE_USER_RESULT:
            return { ...state, createUserLoading: false, createUser: action?.payload }

        case PM_USERS_UPDATE_USER_REQUEST:
            return { ...state, updateUserLoading: true }

        case PM_USERS_UPDATE_USER_RESULT:
            return { ...state, updateUserLoading: false, updateUser: action?.payload }

        case PM_USERS_DELETE_USER_REQUEST:
            return { ...state, deleteUserLoading: true }

        case PM_USERS_DELETE_USER_RESULT:
            return { ...state, deleteUserLoading: false }

        case PM_USERS_SEARCH_ROLES_RESULT:
            return { ...state, roles: action.payload }

        case CLEAR_REDUX:
            return ["", "PM_USERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
